/** Installment attempt statuses that still represent collectible / schedulable balance. */
export const NMI_OPEN_INSTALLMENT_STATUSES = new Set([
  'pending',
  'retrying',
  'declined',
  'error',
  'delinquent',
]);

/** True when a schedule row is an open NMI installment (not paid, skipped, or superseded). */
export function isNmiOpenInstallmentRow(row) {
  if (!row?.date) return false;
  if (row.fee_skipped || row.paid_ahead || row.is_paid) return false;
  if (row._nmi_status) return NMI_OPEN_INSTALLMENT_STATUSES.has(row._nmi_status);
  return false;
}

export function filterNmiOpenInstallmentRows(rows) {
  return (rows || []).filter(isNmiOpenInstallmentRow);
}
